<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="400px"
    title="Guias e Manuais"
    @close="handleClose"
  >
    <div>
      <h4>Manual</h4>
      <p>
        <a
          :href="pdfUrl"
          target="_blank"
          rel="noopener"
          style="color: #409EFF;"
        >
          Sistema Carteira de Pesca (Baixar Manual)
        </a>
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Fechar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Properties from "../../properties.js";

export default {
  name: "GuiasManuaisModal",
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    pdfUrl() {
      return `${Properties.CONTEXT_PATH}pdfs/2025_Carteira_De_Pesca_Manual_V02_LGPD.pdf`;
    }
  },
  methods: {
    handleClose() {
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style scoped>
h4 {
  margin-top: 0;
}
</style>
